import ImageIcon from '@mui/icons-material/Image';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import InsertEmoticonIcon from '@mui/icons-material/InsertEmoticon';
import { he } from 'date-fns/locale';
export const MAX_FILE_SIZE = 250 * 1024;

export const CONTENT_TYPES = [
  { type: 'icon' as const, icon: InsertEmoticonIcon, label: 'Icon' },
  { type: 'text' as const, icon: TextFieldsIcon, label: 'Text' },
  { type: 'image' as const, icon: ImageIcon, label: 'Image' },
];

export const STATE_OPTIONS = [
  { name: 'Default', key: 'default' as const },
  { name: 'Hover', key: 'hover' as const },
];

export const ALIGN_OPTIONS = [
  { name: 'Start', key: 'flex-start' },
  { name: 'Middle', key: 'center' },
  { name: 'End', key: 'flex-end' },
];

export const JUSTIFY_OPTIONS = [
  { name: 'Left', key: 'flex-start' },
  { name: 'Center', key: 'center' },
  { name: 'Right', key: 'flex-end' },
];

export const FONT_WEIGHT_OPTIONS = [
  { name: 'normal', key: 'Normal' },
  { name: 'bold', key: 'Bold' },
];

export const FONT_STYLE_OPTIONS = [
  { name: 'normal', key: 'Normal' },
  { name: 'italic', key: 'Italic' },
];

export const SLIDER_CONFIGS = {
  fontSize: { min: 8, max: 72, step: 1, default: 16 },
  iconSize: { min: 8, max: 72, step: 1, default: 24 },
  imageWidth: { min: 1, max: 300, step: 1, default: 80 },
  imageHeight: { min: 1, max: 300, step: 1, default: 40 },
  borderRadius: { min: 0, max: 50, step: 1, default: 0 },
  padding: { min: 0, max: 30, step: 1, default: 0 },
  opacity: { min: 0, max: 100, step: 1, default: 100 },
};

export const DEFAULT_COLORS = {
  text: '#808080',
  icon: '#333333',
  textHover: '#000000',
  iconHover: '#7d7979',
  backgroundColor: '#ffffff',
  borderColor: '#808080',
  backgroundColorHover: '#f5f5f5',
  borderColorHover: '#666666',
  opacity: 100,
  opacityHover: 70,
};

export const customChipStyles = {
  '&.MuiChip-filled': {
    backgroundColor: 'rgba(224,224,224,1)',
    borderRadius: 1,
    color: '#333',
    fontWeight: 600,
    fontSize: '12px',
    '& .MuiChip-icon': {
      color: '#6b6a6a',
      marginLeft: '8px',
      marginRight: '0',
    },
    '& .MuiChip-label': {
      flexGrow: 1,
      textAlign: 'center',
      paddingLeft: '24px',
    },
    '& .MuiChip-deleteIcon': {
      color: '#6b6a6a',
      marginLeft: 'auto',
      marginRight: '8px',
      '&:hover': {
        color: 'rgba(51, 51, 51, 0.7)',
      },
    },
    '&:hover': {
      boxShadow: '0px 0px 2px 1px rgb(199, 199, 199)',
    },
  },
  '&.MuiChip-outlined': {
    borderColor: 'rgba(224,224,224,1)',
    borderRadius: 1,
    color: '#333',
    fontSize: '12px',
    backgroundColor: 'transparent',
    '& .MuiChip-icon': {
      color: '#6b6a6a',
      marginLeft: '8px',
      marginRight: '0',
    },
    '& .MuiChip-label': {
      flexGrow: 1,
      textAlign: 'center',
      paddingLeft: '24px',
    },
    '& .MuiChip-deleteIcon': {
      color: '#6b6a6a',
      marginLeft: 'auto',
      marginRight: '8px',
    },
    '&:hover': {
      boxShadow: '0px 0px 2px 1px rgb(199, 199, 199)',
      backgroundColor: 'transparent',
    },
  },
};

export const scrollBoxStyles = {
  height: '100%',
  // overflowY: 'auto',
  // overflowX: 'hidden',
  width: '100%',
  pr: 0.5,

  '&::-webkit-scrollbar': {
    width: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0,0,0,0.3)',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
};
